import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled from 'styled-components';
import { CompositeItem, Composite } from '@floating-ui/react';
import { ButtonStyleReset } from '../button/button.js';
import { Text } from '../text/text.js';
import { Tooltip } from '../tooltip/tooltip.js';
import { colors } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import { spacing } from '../../tokens/spacing/spacing.js';
import '../../tokens/breakpoints/breakpoints.js';

function ListBox({ items }) {
    function renderItem({ item }) {
        const renderedItem = (jsxs(StyledItem, { onClick: item.onClick, disabled: item.disabled, "aria-disabled": item.disabled, render: jsx("button", { disabled: item.disabled }), id: item.id, children: [jsxs(LeftWrapper, { children: [item.prefix && jsx("div", { children: item.prefix }), jsx(Text, { color: item.destructive ? "emergency" : "primary", children: item.content })] }), item.suffix && (jsx(Fragment, { children: typeof item.suffix === "string" ? (jsx(Text, { children: item.suffix })) : (jsx(item.suffix, { width: 18 })) }))] }, item.id));
        if (item.tooltip) {
            return (jsx(Tooltip, { title: item.tooltip.title, placement: item.tooltip.placement, children: renderedItem }, item.id));
        }
        return renderedItem;
    }
    return (jsx(Composite, { children: items.map((item) => {
            if (isSection(item)) {
                return (jsxs(Section, { children: [jsx(Text, { variant: "subtitle", marginBottom: spacing.XS2, children: item.title }), item.items.map((sectionItem) => renderItem({ item: sectionItem }))] }, item.title));
            }
            return renderItem({ item });
        }) }));
}
function isSection(item) {
    return "title" in item;
}
const StyledItem = styled(CompositeItem) `
  ${ButtonStyleReset}
  display: block;
  width: 100%;
  border-radius: 0px;
  background: none;
  outline: none;

  display: flex;
  align-items: center;
  gap: ${spacing.S};
  justify-content: space-between;
  padding: ${spacing.XS};
  background-color: ${colors.neutralLight};
  transition: background-color 0.1s;

  &:focus-within,
  &:hover {
    background-color: ${colors.neutral};
  }

  &[disabled] {
    opacity: 0.4;
    cursor: auto;
  }
`;
const LeftWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: ${spacing.S};
`;
const Section = styled.div `
  margin-block: ${spacing.S};
`;

export { ListBox };
